::ng-deep particle-import-field-from-template-dialog particle-file-selector{max-width:100%!important}
/*# sourceMappingURL=import-field-from-template-dialog.component-QMKG5KT3.css.map */
